import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import jordan2 from '../assets/svg/projects/jordan2.svg'
import twouber from '../assets/svg/projects/twouber.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Nike Footwear',
        projectDesc: 'This project aims to offer a wide range of athletic and lifestyle shoes for men, women, and children, featuring innovative designs and high-quality materials.',
        tags: ['React', 'CSS', 'Material Ui'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://nikewear.netlify.app/',
        image: jordan2
    },
    {
        id: 2,
        projectName: 'Uber 2.0 (New Features)',
        projectDesc: "This is an Uber clone app, coded all by myself on React-native and tailwind CSS. The project uses 4 to 5 Google API's, so in order to clone this you need to have Google map's API access from Google Cloud.",
        tags: ['React-native', 'Tailwind CSS'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: six
    },
    {
        id: 3,
        projectName: 'Fat Ape (NFT)',
        projectDesc: "The project is basically a crypto NFT website, where NFT lovers especially Ape lovers will buy tokens to make their way for a really special prizes like Lamborghini Hurricane etc.",
        tags: ['HTML', 'CSS', 'Javascript'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://salmankarimo.netlify.app',
        image: three
    },
    {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: one
    },
    {
        id: 7,
        projectName: 'HBL Bank Management System',
        projectDesc: 'This is a C++ bank management system project. Its a simple console application. Main focus of the project are, how to add, edit, search, delete or modify records in a file, and how to use file as database overall.',
        tags: ['C++', 'Console', 'DS'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: seven
    },
    {
        id: 8,
        projectName: 'Gulmit.com',
        projectDesc: "I created this website when I was 14 this was for my hometown Gulmit, Hunza. Have included lots of images of my hometown and history etc. Do check the website and know about my culture and language.",
        tags: ['HTML', 'Notepad'],
        code: 'https://github.com/Salman-Pixel',
        demo: 'https://github.com/Salman-Pixel',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/